<template>
    <div id="dashboardLoading" v-if="showDashboardLoader">
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus.js';
    export default {
        name: "DashboardLoading",
        data(){
            return {
                showDashboardLoader: false
            }
        },
        created: function () {
            EventBus.$on('toggleDashboardLoader', (state) => { // here you need to use the arrow function
                if("show" === state){
                    this.showDashboardLoader = true;
                }else{
                    this.showDashboardLoader = false;
                }
            });
        }
    }
</script>

<style scoped lang="scss">
$offset: 187;
$duration: 1.4s;

.spinner {
    animation: rotator $duration linear infinite;
}

@keyframes rotator {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(270deg); }
}

.path {
    stroke-dasharray: $offset;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation:
    dash $duration ease-in-out infinite,
    colors ($duration*4) ease-in-out infinite;
}

@keyframes colors {
    0% { stroke: #CE0702; }
    25% { stroke: #666666; }
    50% { stroke: #CE0702; }
    75% { stroke: #666666; }
    100% { stroke: #CE0702; }
}

@keyframes dash {
    0% { stroke-dashoffset: $offset; }
    50% {
        stroke-dashoffset: $offset/4;
        transform:rotate(135deg);
    }
    100% {
        stroke-dashoffset: $offset;
        transform:rotate(450deg);
    }
}
#dashboardLoading {
    position: absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background:rgba(255,255,255,0.5);
    text-align:center;
    z-index:4;
svg {
    top:40%;
    margin-top:-50px;
    position: absolute;
    left:50%;
    margin-left:-50px;
    width:100px;
    z-index: 1;
    height:100px;
    opacity:0.5;
}

}</style>